module.exports = __webpack_public_path__ + "img/sales_question.ccf59908.png";